module.exports = __webpack_public_path__ + "img/lake-cabin-4.2b34b00e.jpg";